// import React, { useState, useEffect } from "react";
export default function Son() {
  return (
    <img
      className="svg_lifeline"
      src="/svg/son.svg"
      alt=""
    />
  );
}
